import React from 'react'
import './BlogPost.css'
import { Link, Route } from 'react-router-dom';

const BlogPost = ({ img, title, desc, story, postID }) => {
    const [display, setDisplay] = React.useState(false);
    function handleDisplay() {
        if (display) {
            return (
                <div className='postContainer'>
                    <div className='postWindow'>
                        <div className='postHeader'>
                            <div className='postTitle'>
                                <h1>{title}</h1>
                            </div>
                            <button className='close' onClick={handleClick}>✖</button>
                        </div>
                        <div className='postBody'>
                            <img src={img} alt="Blog Post" />
                            <p>{story}</p>
                        </div>
                    </div>
                </div>
            )
        }
    }

    function handleClick() {
        console.log(display)
        if (display) {
            setDisplay(false);
        }
        else {
            setDisplay(true);
        }
    }

    return (
        <div className='blogPost'>
            <img src={img} alt="Blog Post" />
            <h1>{title}</h1>
            <p>{desc}</p>
            <button className='readMore' onClick={handleClick}>Read More</button>
            {handleDisplay()}
        </div>
    )
}

export default BlogPost;